/* ==========================================================================
   Naar Halı — ürün sayfası küçük düzeltmeleri (16 Eki 2026)

   1) Judge.me yorum alanı iki sekmeli: "Ürün Değerlendirmeleri" ve "Mağaza Değerlendirmeleri".
      Yeni ürünlerde ürün yorumu 0 oluyor; müşteri sayfanın dibinde "İlk değerlendirmeyi yapan
      siz olun" görüyordu, oysa mağazanın yüzlerce yorumu var. Ürün yorumu 0 ise Mağaza sekmesi
      kendiliğinden seçilir (kullanıcı sekmeye dokunduysa karışılmaz).

   1b) Yorum alanı sadeleştirildi (16 Eki 2026, ikinci tur): ürün yorumu 0 ise iki sekme hiç
      gösterilmez (boş bir "Ürün (0)" sekmesi karışıklık yaratıyordu), başlığın altına tek cümlelik
      açıklama konur; iki sekme de doluysa etiketler kısaltılır ("Ürün Yorumları (3)",
      "Mağaza Yorumları (142)"; uzun etiketler telefonda kırpılıyordu). Yorum listesi 2.300 px'lik
      bir duvardı: ilk yorumlar görünür, geri kalanı "Daha fazla yorum göster" ile açılır.
      Biçim kuralları assets/naar-duzeltmeler.css'te ("naar-yorum").

   2) Judge.me'nin yorumdaki ürün küçük resimleri 250–360 KB'lık orijinal dosyalar (50 px'lik
      kutuda). Tembel yüklenir ve Shopify CDN'den küçük boyutu istenir; sayfa ağırlığı düşer.
   ========================================================================== */
(function () {
  var kullanici = false;
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.target.closest && e.target.closest('.jdgm-tab')) kullanici = true;
    },
    true
  );

  var denemeler = 0;
  var genisletildi = false;
  var dugme = null;

  function sayi(sekme) {
    var m = sekme.textContent.match(/\((\d+)\)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  // "Değerlendirmeleri" → "Yorumları" (yalnızca sekme ve başlık yazıları; Vue yeniden çizerse tekrar uygulanır)
  function kisalt(kok) {
    var yuru = document.createTreeWalker(kok, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = yuru.nextNode())) {
      if (/de[ğg]erlendirmeleri/i.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(/Değerlendirmeleri/g, 'Yorumları').replace(/değerlendirmeleri/g, 'yorumları');
      }
    }
  }

  function yorum() {
    var widget = document.querySelector('.jdgm-widget.jdgm-review-widget');
    if (!widget) return false;
    var bolum = widget.closest('.shopify-section') || widget.parentElement;
    var sekmeler = widget.querySelectorAll('.jdgm-tablist__list .jdgm-tab');
    if (sekmeler.length < 2) return false;

    var urunBos = sayi(sekmeler[0]) === 0;
    var ilkAktif = sekmeler[0].classList.contains('jdgm-tab--active');
    if (urunBos && !kullanici && ilkAktif) sekmeler[1].click();
    bolum.classList.add('naar-yorum');
    bolum.classList.toggle('naar-yorum--tek', urunBos);

    var baslik = widget.querySelector('.jm-review-widget-minimal-header__title');
    if (baslik) kisalt(baslik);
    kisalt(widget.querySelector('.jdgm-tablist') || widget);

    // Kısa görünüm: içerik uzunsa kes, düğmeyle aç
    if (!dugme) {
      dugme = document.createElement('button');
      dugme.type = 'button';
      dugme.className = 'naar-yorum__daha';
      dugme.textContent = 'Daha fazla yorum göster';
      dugme.setAttribute('aria-expanded', 'false');
      dugme.addEventListener('click', function () {
        genisletildi = true;
        bolum.classList.remove('naar-yorum--kisa');
        dugme.hidden = true;
      });
      widget.insertAdjacentElement('afterend', dugme);
    }
    if (!genisletildi) {
      bolum.classList.add('naar-yorum--kisa');
      var uzun = widget.scrollHeight > widget.clientHeight + 40;
      dugme.hidden = !uzun;
      if (!uzun && widget.scrollHeight > 0) bolum.classList.remove('naar-yorum--kisa');
    }
    return true;
  }

  // Rozetler görselin sol üstünde (assets/naar-duzeltmeler.css madde 9): bilgi sütunundaki gizli rozet
  // bloğunun (tema ölçü değişince onu günceller) içeriği görsel üstündeki kutuya yansıtılır.
  function rozet() {
    var kaynak = document.querySelector('.product__badges[id^="Badges-"]');
    var hedef = document.querySelector('[data-naar-rozet]');
    if (!kaynak || !hedef) return;
    var html = kaynak.classList.contains('hidden') ? '' : kaynak.innerHTML.trim();
    if (hedef.dataset.son !== html) {
      hedef.dataset.son = html;
      hedef.innerHTML = html;
    }
  }

  function sekme() {
    if (yorum()) return;
    if (++denemeler < 40) setTimeout(sekme, 500);
  }

  function kucult(img) {
    if (img.dataset.naarKucuk) return;
    img.dataset.naarKucuk = '1';
    if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
    img.decoding = 'async';
    var src = img.getAttribute('src') || '';
    // Yalnızca Shopify CDN'deki mağaza dosyaları; boyut parametresi yoksa ekle
    if (/^https:\/\/cdn\.shopify\.com\/s\/files\//.test(src) && src.indexOf('width=') === -1) {
      img.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=360');
    }
  }
  function tara(kok) {
    var liste = (kok.querySelectorAll ? kok.querySelectorAll('[class*="jdgm"] img') : []);
    for (var i = 0; i < liste.length; i++) kucult(liste[i]);
    if (kok.matches && kok.matches('[class*="jdgm"] img')) kucult(kok);
  }

  function basla() {
    sekme();
    rozet();
    tara(document);
    if (!window.MutationObserver) return;
    var bekle;
    new MutationObserver(function (kayitlar) {
      clearTimeout(bekle);
      bekle = setTimeout(function () { yorum(); rozet(); }, 250);
      for (var i = 0; i < kayitlar.length; i++) {
        var eklenen = kayitlar[i].addedNodes;
        for (var j = 0; j < eklenen.length; j++) if (eklenen[j].nodeType === 1) tara(eklenen[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
